/* ============================================
   I18N - Système d'internationalisation
   ============================================ */

import { fr } from './fr.js';
import { en } from './en.js';
import { es } from './es.js';
import { it } from './it.js';
import { de } from './de.js';
import { pt } from './pt.js';

// Langues disponibles
export const LANGUAGES = {
  fr: { code: 'fr', name: 'Français', flag: '🇫🇷', translations: fr },
  en: { code: 'en', name: 'English', flag: '🇬🇧', translations: en },
  es: { code: 'es', name: 'Español', flag: '🇪🇸', translations: es },
  it: { code: 'it', name: 'Italiano', flag: '🇮🇹', translations: it },
  de: { code: 'de', name: 'Deutsch', flag: '🇩🇪', translations: de },
  pt: { code: 'pt', name: 'Português', flag: '🇵🇹', translations: pt },
};

// Langue actuelle (français par défaut)
let currentLanguage = 'fr';
let currentTranslations = fr;

/**
 * Définir la langue actuelle
 * @param {string} languageCode - Code de la langue (fr, en, es, it, de, pt)
 */
export function setLanguage(languageCode) {
  if (LANGUAGES[languageCode]) {
    currentLanguage = languageCode;
    currentTranslations = LANGUAGES[languageCode].translations;
    return true;
  }
  console.warn(`⚠️ Langue non trouvée: ${languageCode}`);
  return false;
}

/**
 * Obtenir la langue actuelle
 * @returns {string} Code de la langue actuelle
 */
export function getCurrentLanguage() {
  return currentLanguage;
}

/**
 * Obtenir une traduction
 * @param {string} key - Clé de traduction (ex: 'events.goal')
 * @param {string} defaultValue - Valeur par défaut si traduction non trouvée
 * @returns {string} Traduction
 */
export function t(key, defaultValue = key) {
  const keys = key.split('.');
  let value = currentTranslations;

  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      console.warn(`⚠️ Traduction manquante: ${key}`);
      return defaultValue;
    }
  }

  return value || defaultValue;
}

/**
 * Obtenir toutes les traductions pour la langue actuelle
 * @returns {object} Objet de traductions
 */
export function getTranslations() {
  return currentTranslations;
}

/**
 * Obtenir la liste des langues disponibles
 * @returns {object} Langues disponibles
 */
export function getAvailableLanguages() {
  return LANGUAGES;
}


